<template>
    <div class="main-wrapper">
        <img src="@/assets/icon/pagetitle.gif" alt="."/>
        <div style="color: #004F9A;font-size: 24px;font-weight: bold;">{{$t("usrinquire.title")}}</div>
        <div align="left">
            <div>{{$t("usrinquire.send_confirm")}} </div>
            <div>{{$t("usrinquire.confirm_text1")}}</div>
            <div>{{$t("usrinquire.confirm_text2")}}</div>
        </div>
        <div style="display: flex;gap:8px;" class="button-group">
            <BButton style="flex: 1" @click="close()">{{$t("usrinquire.close")}}</BButton>
        </div>
    </div>
</template>
<script>
export default {
    name: 'usrinquire_confirm',
    setup(){
        gtag('event', 'viewInquiryFinish', {
          'event_name': 'view'
        })
        function close(){
            window.close();
        }
        return{
            close
        }
    }
}
</script>
<style scoped lang="scss">
    .main-wrapper{
        margin: 0px 16px;
        .button-group{
            button{
                margin-top:24px;
                width:100%;
                background: #2394F7;
                border-radius: 4px;
                font-weight: 600;
                font-size: 13px;
                line-height: 18px;
                color: #FFFFFF;
                height: 40px;
                padding: 8px 16px;
                border: none;
            }
        }
    }
</style>